var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.permissionsHeaders,"items":_vm.value,"item-key":"name","hide-default-header":_vm.$vuetify.breakpoint.smAndDown,"hide-default-footer":"","disable-sort":""},scopedSlots:_vm._u([{key:"item.role",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.name))]}},{key:"item.units",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(!_vm.hasUnits(item) ? 'Todas' : _vm.joinUnitsNames(item.units)))]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.removeRole(item)}}},[_c('v-icon',[_vm._v("mdi-delete")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }